import { Http } from "../Http";
export class PasswordhistoryApi {
public static getpasswordhistory(input: any) {
    if (input === "") {
      return { data: [] };
    }

    var url = "/api/getdescending/" + input;
    const resultMethod = Http.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*"
        }
      })
      .then(res => {
        return res;
      })
      .catch((e: any) => {
        return e.response;
      });
    return resultMethod;
  }
}